import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import getSymbolFromCurrency from "currency-symbol-map";

import { useAppSelector } from "store/index";
import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

import ModalTabSkeleton from "components/global/Skeleton/ModalTabSkeleton/ModalTabSkeleton";

interface Props {
  id: string | number;
  canBeUpdated?: boolean;
  onLoadingChange?: (isLoading: boolean) => void;
}

const GamesFSTab: React.FC<Props> = ({ id, onLoadingChange }) => {
  const { t } = useTranslation();

  const currenciesList = useAppSelector((store) => store.settings.currencies);

  const [activeTab, setActiveTab] = useState<string>("");
  const [isFetched, setFetched] = useState<boolean>(false);

  useEffect(() => {
    if (currenciesList.length > 0) {
      setActiveTab(currenciesList[0]);
    }
  }, [currenciesList]);

  const [items, setItems] = useState<
    {
      spinAmount: number;
      id: string;
      denomination: number;
    }[]
  >([]);

  useEffect(() => {
    onLoadingChange?.(!isFetched);
  }, [isFetched, onLoadingChange]);

  const handleLoadItem = async () => {
    if (!activeTab) return;
    try {
      const result = await instance.get(
        `${apiRoutes.gameSpinsList}?gameId=${id}&currency=${activeTab}`,
      );
      setItems(result.data);
    } catch {
      console.log("handleLoadItem");
    }
    setFetched(true);
  };

  useEffect(() => {
    setItems([]);
    setFetched(false);
    handleLoadItem();
  }, [activeTab, id]);

  const handleTabClick = (e: string) => {
    onLoadingChange?.(true);
    setActiveTab(e);
  };

  return (
    <div className="game-geos-wrapper">
      <div className="game-modal-tabs small">
        {currenciesList?.map((el) => (
          <div
            className={`tab-item ${activeTab === el ? "active" : ""}`}
            key={el}
            onClick={() => {
              handleTabClick(el);
            }}
          >
            <div className="currency-tab-item">
              <div className="currency">{getSymbolFromCurrency(el)}</div> {el}
            </div>
          </div>
        ))}
      </div>
      <div className="games-order-list fs-game-list">
        {isFetched ? (
          <>
            <div className="item">
              <div className="order">ID</div>
              <div className="spinAmount">{t("spinAmount")}</div>
              <div className="id">{t("betId")}</div>
              <div className="denomination">{t("denomination")}</div>
            </div>
            {items?.map((el, idx) => (
              <div className="item" key={el.id}>
                <div className="order">{idx + 1}</div>
                <div className="spinAmount">{el.spinAmount}</div>
                <div className="id">{el.id}</div>
                <div className="denomination">{el.denomination}</div>
              </div>
            ))}
          </>
        ) : (
          <ModalTabSkeleton />
        )}
      </div>
    </div>
  );
};

export default GamesFSTab;
